import RelaxIcon from 'icons/face-eyes-closed-outline.svg';
import MindIcon from 'icons/mind-outline.svg';
import SleepIcon from 'icons/sleep-outline.svg';

import { valuePropMessages } from '../messages';
import { IconBubble } from './styles';
import type { ValueProp } from './types';

const valueProps: Record<string, ValueProp> = {
	stressLess: {
		label: valuePropMessages.vpLabel1,
		body: valuePropMessages.vpBody1,
		icon: (
			<IconBubble $icon="mind">
				<MindIcon />
			</IconBubble>
		),
	},
	relaxMore: {
		label: valuePropMessages.vpLabel2,
		body: valuePropMessages.vpBody2,
		icon: (
			<IconBubble $icon="relax">
				<RelaxIcon />
			</IconBubble>
		),
	},
	sleepBetter: {
		label: valuePropMessages.vpLabel3,
		body: valuePropMessages.vpBody3,
		icon: (
			<IconBubble $icon="sleep">
				<SleepIcon />
			</IconBubble>
		),
	},
} as const;

export default valueProps;
